import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from '@/views/login/index'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    // component: Login,
    component: (resolve) => require(['@/views/index'], resolve),
  },{
    path: '/news/detail',
    component: (resolve) => require(['@/views/news/detail'], resolve),
  },{
    path: '/news/inDetail',
    component: (resolve) => require(['@/views/news/inDetail'], resolve),
  },{
    path: '/news/list',
    component: (resolve) => require(['@/views/news/list'], resolve),
  },{
    path: '/mine/home',
    component: (resolve) => require(['@/views/mine/home'], resolve),
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes,
})

export default router
